"use client";
import { Row } from "@/utils/bootstrap";
import AttachmentsSlider from "./AttachmentsSlider";
import AttachmentMedia from "./AttachmentMedia";

import useIsClient from "@/hooks/useIsClient";
import AttachmensSkeleton from "./AttachmensSkeleton";

import { useRef } from "react";

import { ReviewAttachment } from "@/api/AppApi/services/reviews/interfaces";
import MediaPreviewModal from "@/app/components/lib/media-preview-provider/MediaPreviewModal";

interface Props {
  attachments: ReviewAttachment[];
}

const Attachments: React.FC<Props> = ({ attachments }) => {
  const isClient = useIsClient();
  const mediaPreviewRef = useRef<{
    showMedia(src: string, type: "video" | "image"): void;
  } | null>(null);

  return (
    <>
      {isClient ? (
        <Row style={{ gap: 12 }} className="m-0 d-flex justify-content-center">
          <AttachmentsSlider>
            {attachments.map((attachment, key) => (
              <div
                key={key}
                onClick={() => {
                  mediaPreviewRef.current?.showMedia(
                    attachment.value,
                    attachment.type,
                  );
                }}
              >
                <AttachmentMedia
                  key={key}
                  src={attachment.value}
                  type={attachment.type}
                  className={"attachment"}
                />
              </div>
            ))}
          </AttachmentsSlider>

          <MediaPreviewModal ref={mediaPreviewRef} />
        </Row>
      ) : (
        <AttachmensSkeleton
          media={attachments as []}
          className={"attachment"}
        />
      )}
    </>
  );
};

export default Attachments;
